import { render, staticRenderFns } from "./DesktopLogo.vue?vue&type=template&id=372f30ea&scoped=true&"
var script = {}
import style0 from "./DesktopLogo.vue?vue&type=style&index=0&id=372f30ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372f30ea",
  null
  
)

export default component.exports